import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateGridPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  // Sort by PnL descending
  const sorted = starsData.map((_, i) => i).sort((a, b) => starsData[b].pnl - starsData[a].pnl);
  const count = sorted.length;
  const positions: StarPosition[] = new Array(count);

  const cols = Math.ceil(Math.sqrt(count * 1.5));
  const rows = Math.ceil(count / cols);
  const spacing = Math.min(0.9, 140 / cols);
  const offsetX = ((cols - 1) * spacing) / 2;
  const offsetZ = ((rows - 1) * spacing) / 2;

  sorted.forEach((idx, rank) => {
    const col = rank % cols;
    const row = Math.floor(rank / cols);
    const pnlHeight = Math.max(0, starsData[idx].pnl / 2000) * 3;

    positions[idx] = {
      x: col * spacing - offsetX,
      y: pnlHeight + (Math.random() - 0.5) * 0.3,
      z: row * spacing - offsetZ,
    };
  });

  return positions;
};
